import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDoorHanger: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDoorHanger"><Path d="M12 1C8.13401 1 5 4.13401 5 8V10H10V8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8V8.11696C14 9.40825 13.1737 10.5547 11.9487 10.963L8.41886 12.1396C6.37715 12.8202 5 14.7309 5 16.883V23H19V8C19 4.13401 15.866 1 12 1Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDoorHanger;
